<template>
  <a
    class="frisbuy-sr-branding"
    target="_blank"
    :href="`https://frisbuy.ru/s/frisbuystories/?utm_source=stories&utm_medium=referral&utm_campaign=${utmCampaing}`"
  >
    <span>
      powered by
      <svg
        width="51"
        height="14"
        viewBox="0 0 51 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.7">
          <path
            d="M46.1607 0C48.6476 0 50.6627 1.98965 50.6627 4.4367C50.6627 6.88375 48.6437 8.8734 46.1607 8.8734C43.6738 8.8734 41.6587 6.88375 41.6587 4.4367C41.6587 1.98965 43.6776 0 46.1607 0Z"
            fill="currentColor"
          />
          <path
            d="M46.161 1.38721C47.8705 1.38721 49.259 2.75557 49.259 4.4403C49.259 6.12502 47.8705 7.49339 46.161 7.49339C44.4515 7.49339 43.063 6.12502 43.063 4.4403C43.063 2.75557 44.4515 1.38721 46.161 1.38721Z"
            fill="white"
          />
          <path
            d="M46.1607 1.8335C47.6188 1.8335 48.8023 2.99984 48.8023 4.43682C48.8023 5.87379 47.6188 7.04014 46.1607 7.04014C44.7026 7.04014 43.519 5.87379 43.519 4.43682C43.519 2.99984 44.7026 1.8335 46.1607 1.8335Z"
            fill="currentColor"
          />
          <path
            d="M34.3334 7.26106V7.29917C34.3334 8.47315 35.2501 9.42605 36.3833 9.42605H36.3949H36.4065C37.5398 9.42605 38.4564 8.47696 38.4564 7.29917V7.26106H38.468V4.40998H39.5355V10.741C39.5355 12.5363 38.1238 14 36.3911 14C36.2712 14 36.1513 13.9923 36.0352 13.9771V12.8298C36.1551 12.8527 36.2789 12.8641 36.4065 12.8641C37.5398 12.8641 38.4564 11.915 38.4564 10.7372V10.6991H38.468V9.74622C37.9149 10.2532 37.1878 10.5619 36.3949 10.5619C34.6661 10.5619 33.2544 9.09444 33.2544 7.30299V4.41379H34.3218V7.26487H34.3334V7.26106ZM26.95 7.26106H26.9616V7.29917C26.9616 8.47315 27.8783 9.42605 29.0115 9.42605H29.0231H29.0347C30.1679 9.42605 31.0846 8.47696 31.0846 7.29917V7.26106H31.0962V4.40998H32.1637V7.29917C32.1637 9.09444 30.752 10.5581 29.0231 10.5581C27.2943 10.5581 25.8826 9.09063 25.8826 7.29917V4.40998H26.95V7.26106ZM16.5189 10.5505H13.4325V9.50228H16.5189C16.7703 9.50228 16.9443 9.41461 17.0333 9.30408C17.0836 9.24309 17.1068 9.15542 17.1222 9.07157C17.1338 8.97247 17.1106 8.86193 17.072 8.76283C16.9714 8.53032 16.7471 8.30544 16.3835 8.1949L16.1708 8.14535L14.9099 7.82518L14.8867 7.81374C14.1635 7.6041 13.6993 7.13528 13.4866 6.6169C13.3861 6.35771 13.3474 6.08709 13.3745 5.81646C13.3977 5.5344 13.4982 5.27522 13.6761 5.05414C13.9623 4.68442 14.4265 4.43666 15.0376 4.43666H17.7681V5.48485H15.0492C14.7978 5.48485 14.6237 5.57252 14.5348 5.68306C14.4845 5.74404 14.4613 5.83171 14.4458 5.91556C14.4342 6.01467 14.4574 6.11377 14.4961 6.2243C14.5966 6.45681 14.821 6.6817 15.1845 6.79223L15.3973 6.84178L16.6581 7.16196L16.6813 7.17339C17.393 7.38303 17.8571 7.85186 18.0698 8.37023C18.1704 8.62942 18.2091 8.91148 18.182 9.17067C18.1588 9.45273 18.0582 9.71192 17.8803 9.93299C17.5941 10.3027 17.1416 10.5505 16.5189 10.5505ZM12.102 10.5505H11.0384V4.46716C11.2086 4.45572 11.3787 4.4481 11.5528 4.4481H12.102V10.5505ZM6.7259 10.5505H5.66229V5.49629V4.4481H6.7259V5.26759C7.27898 4.75684 7.94809 4.45953 8.80285 4.4481H8.80672C9.13934 4.45191 9.47196 4.4481 9.80458 4.49765V5.58777C9.61507 5.55346 9.41008 5.53822 9.20122 5.53822C8.93822 5.53822 8.69069 5.5649 8.46636 5.61445C7.48784 5.77835 6.73751 6.65501 6.73751 7.71083L6.7259 8.10723V10.5505ZM19.9805 4.45191H22.0071C23.7089 4.45191 25.0935 5.82027 25.109 7.48213C25.109 9.17067 23.7205 10.539 22.0226 10.539C20.3208 10.539 18.9362 9.17067 18.9362 7.49738L18.9246 4.44048V2.00486H19.9882L19.9805 4.45191ZM2.13883 10.5238H1.07522V5.48485H0V4.43666H1.05588V3.55237C1.05588 1.75711 2.46758 0.293457 4.20031 0.293457C4.3202 0.293457 4.4401 0.30108 4.55613 0.316327V1.46362C4.43624 1.44075 4.31247 1.42931 4.18484 1.42931C3.0516 1.42931 2.12723 2.3784 2.12723 3.55619L2.13496 4.45191H4.40143V5.5001H2.13883V10.5238ZM21.9685 5.51154V5.5001H19.9805V7.45926H19.9921C19.9921 7.4707 19.9921 7.48213 19.9921 7.49738C19.9921 8.59512 20.8932 9.47941 22.0033 9.47941C23.1133 9.47941 24.0145 8.59131 24.0145 7.49738C24.0145 6.39964 23.1133 5.51535 22.0033 5.51535H21.9685V5.51154ZM11.5528 2.00486C11.2008 2.00486 10.9107 2.29073 10.9107 2.63759C10.9107 3.02637 11.2704 3.33511 11.6804 3.25507C11.9279 3.20933 12.1291 3.01113 12.1793 2.76337C12.2606 2.36315 11.9473 2.00486 11.5528 2.00486Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </span>
  </a>
</template>

<style scoped lang="scss">
.frisbuy-sr-branding {
  width: 64px;
  height: 35px;
  flex-shrink: 0;
  font-size: 8px;
  line-height: 9px;
  color: #000000;
  opacity: 0.5;
  text-decoration: none;
  text-align: center;

  // span {
  //   display: flex;
  //   align-items: center;
  // }

  svg {
    margin-top: 4px;
  }
}
</style>

<script>
export default {
  data() {
    return {};
  },

  props: {
    utmCampaing: {
      type: String,
      require: true,
    },
  },
};
</script>
